import { useEffect, useRef, useState } from "react";
import { api } from "../api";
import type { AnnouncementConfig } from "../announcementPresentation";

export function useAnnouncementConfig(enabled = true) {
  const [value, setValue] = useState<AnnouncementConfig | null>(null), [loading, setLoading] = useState(true), [error, setError] = useState("");
  const generation = useRef(0);
  const reload = async () => {
    const current = ++generation.current; setValue(null); setLoading(true); setError("");
    try { const next = await api.getAnnouncementMessageConfig(); if (current === generation.current) setValue(next); }
    catch { if (current === generation.current) setError("전송 설정을 확인하지 못했습니다. 설정을 다시 확인해 주세요."); }
    finally { if (current === generation.current) setLoading(false); }
  };
  useEffect(() => { if (enabled) void reload(); return () => { generation.current++; }; }, [enabled]);
  return { value, loading, error, reload };
}
